import { useEffect } from "react";
import { FileDeliveriesCard } from "./card";
import { FileDeliveriesNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { FileDeliveriesTable } from "./table";

export default function FileDeliveries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Livraisons de fichiers");
  }, []);

  return (
    <Routes>
      <Route index element={<FileDeliveriesTable />} />
      <Route path="/new" element={<FileDeliveriesNew />} />
      <Route path=":id" element={<FileDeliveriesCard />} />
    </Routes>
  );
}
